import { Field } from '@models/company/field';
import { GeoPoint } from '@wizbii/models';

export class CompanyFilter {
  keywords: string;
  geoPoint: GeoPoint;
  fields: Field[];
  page: number;
  companyId: string;

  constructor(data = {}) {
    this.keywords = data['keywords'] || '';
    this.geoPoint = data['geoPoint'] || [];
    this.fields = data['fields'] || [];
    this.page = data['page'] || 0;
    this.companyId = data['companyId'] || '';
  }
}
